import MessageApi from '../../../../api/inbox/message';
import types from '../../../mutation-types';

export default {
  async reactToMessage({ commit }, { conversationId, messageId, emoji }) {
    const { data } = await MessageApi.react(conversationId, messageId, emoji);
    commit(types.ADD_MESSAGE, data);
  },
};
